import { WorkInProgressItemStatus } from "../graphql"

export const getWIPItemStatusColorScheme = (severity: WorkInProgressItemStatus) => {
	switch (severity) {
		case WorkInProgressItemStatus.Pending:
			return "orange"
		case WorkInProgressItemStatus.InProgress:
			return "purple"
		default:
			return "green"
	}
}
